import React from "react";
import PropTypes from "prop-types";
import "./index.scss";
import { Crown } from "phosphor-react";

const CalculationsCard = ({ title, description, imgSrc, advanced }) => {
  return (
    <div className="calculations-card">
      <label className={`tier ${advanced ? "-orange" : ""}`}>
        {advanced ? "Unlock with Advanced" : "Included in Basic"}
        {advanced ? <Crown size={20} color="#f7901e" /> : null}
      </label>
      <h4 className="title">{title}</h4>
      <p className="description">{description}</p>
      <div className="image-container">
        <img className="image" src={imgSrc} alt="calculation-card" />
      </div>
    </div>
  );
};

CalculationsCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  advanced: PropTypes.bool,
};

CalculationsCard.defaultProps = {
  advanced: false,
};

export default CalculationsCard;
